import { LocalService } from './../storage/local.service';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { ConfigService } from './../config/config.service';
import { EncryptService } from '../utils/encrypt.service';
import { API_ENDPOINT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class EstadosService {
  headers = new HttpHeaders({
    'accept': 'application/json',
    'Content-Type': 'application/json'
  });

  headers1 = new HttpHeaders({
    'accept': 'application/json',
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService,
    private localSecureService: LocalService,
    private encriptado: EncryptService
  ) { }

  async getEmiStatus(data:any) {
    //const config =  await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/getemistatus`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error:any) {
      return { status: false, code: error.error.status, message: error.error.message };
    }
  }

  async getSeries(idOficina:number) {
    //const config =  await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const params = `IdOficina=${idOficina}`;
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/getseriesderivar?${params}`;

    try {
      return await this.httpClient.post(url, { headers: this.headers1 }).toPromise();
    } catch (error:any) {
      return { status: false, code: error.error.status, message: error.error.message };
    }
  }

  async listaGetEdoSessions(data:any){
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/getedosession`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error:any) {
      return { status: false, code: error.error.status, message: error.error.title };
    }
  }

}
